import React from 'react';
import getDesignSystemTheme from 'shared-assets/lib/utils/getDesignSystemTheme';
import { Box, Typography, ThemeProvider, Button } from '@kareo/design-system';
import { Grid } from '@material-ui/core';
function FeatureGridItem(_a) {
    var title = _a.title, description = _a.description;
    return (React.createElement(Grid, { item: true, xs: 12, md: 4, style: { textAlign: 'center', lineHeight: '1' } },
        React.createElement(Typography, { variant: "h4", style: { fontWeight: 'bold', margin: 0 } }, title),
        React.createElement(Typography, { variant: "caption" }, description)));
}
var TebraPayBanner = function () {
    var theme = getDesignSystemTheme();
    return (React.createElement(ThemeProvider, { theme: theme },
        React.createElement(Box, { bgcolor: "core.200", padding: 2, paddingX: 4, width: "100%" },
            React.createElement(Grid, { container: true, spacing: 2 },
                React.createElement(Grid, { item: true, xs: 3, style: { marginTop: 'auto', marginBottom: 'auto' } },
                    React.createElement("img", { src: "/static/assets/img/input_credit_card_photography-640x640.png", alt: "Man using card and phone", style: {
                            borderRadius: '50%',
                            overflow: 'hidden',
                            width: '160px',
                            height: '160px',
                        } })),
                React.createElement(Grid, { item: true, xs: 9 },
                    React.createElement(Box, { display: "flex", flexDirection: "column", height: "100%", alignItems: "center", justifyContent: "space-between", style: { gap: '16px' } },
                        React.createElement(Box, { textAlign: "center" },
                            React.createElement(Typography, { variant: "h2", style: { fontWeight: 'bold', margin: 0 } }, "Introducing Tebra Payments"),
                            React.createElement(Typography, { variant: "body1", style: { margin: 0 } }, "Simplify patient payments with Tebra's own ",
                                React.createElement("b", null, "All-in-One Solution!"))),
                        React.createElement(Grid, { container: true, spacing: 1 },
                            React.createElement(FeatureGridItem, { title: "2.75% + $0.30", description: "Processing fee per transaction" }),
                            React.createElement(FeatureGridItem, { title: "Cancel any time", description: "No long-term contracts" }),
                            React.createElement(FeatureGridItem, { title: "No Monthly Fees", description: "Pay per transaction only" })),
                        React.createElement(Box, { textAlign: "center" },
                            React.createElement(Button, { href: "/v2/#/payments-onboarding", color: "vitality" }, "Apply Now"))))))));
};
export default TebraPayBanner;
